/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".msAnalyticsActivityListActivity_8d420d9b{padding:8px 0}\n"}]);
export const msAnalyticsActivityListActivity = "msAnalyticsActivityListActivity_8d420d9b";